
import axios from '../../../helpers/private.axios'



export const getAllDocumentTemplates = () => {

    return axios.get(`/api/documents/templates`);

}